window.addEventListener('load', function () {
  const interval = setInterval(() => {
    if(window?.Trustpilot?.loadFromElement) {
      const products = document.querySelectorAll('.ProductCard');

      products.forEach(product => {
        const sku = product.dataset.productSku
        const name = product.dataset.productName
        const url = product.dataset.productUrl
        const hasReviews = product.querySelector('.trustpilot-widget')

        if(!hasReviews && sku) {
          // Render reviews below the product title
          const title = product.querySelector('.ProductCard__Title')
          const reviews = `
            <div
              class="trustpilot-widget my-3"
              data-locale="en-GB"
              data-template-id="54d39695764ea907c0f34825"
              data-businessunit-id="5ec1dfd6012e830001d92051"
              data-style-height="24px"
              data-style-width="100%"
              data-theme="light"
              data-sku="${ sku }"
              data-name="${ name }"
              data-no-reviews="hide"
              data-scroll-to-list="true"
              data-style-alignment="left"
              data-product-url="${ url }"
              data-stars="4"
            >
              <a
                href=https://uk.trustpilot.com/review/rescueswag.com.au
                target="_blank"
                rel="noopener"
              >
                Trustpilot
              </a>
            </div>
          `
          title.insertAdjacentHTML('afterend', reviews)

          const reviewsElement = product.querySelector('.trustpilot-widget')
          window.Trustpilot.loadFromElement(reviewsElement)
        }
      });

      clearInterval(interval)
    }
  }, 2000)
});